/**
 * Constant for imperial measurement system
 * @constant {string}
 */
export const IMPERIAL = 'imperial'
